import React from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';
import ColumnVisibilityBar from './ColumnVisibilityBar';
import { statePillFor } from '../utils/offerHeaderHelpers';
import '../styles/lineup.css';

const V3OfferEventHeader = ({
  offer,
  confirm,
  team,
  offerActive,
  forecastActive,
  actualsActive,
  onToggleColumn,
  onLinkEvent,
  templateBar,
}) => {
  if (!offer) return null;

  // Date, venue, and capacity chips are intentionally omitted from this header —
  // EventDetails renders the same pill row + Edit Details inline below and the
  // two were producing visibly duplicated copy.
  const eventTitle = offer.event_name;
  const { label: stateLabel, modifier: stateModifier } = statePillFor(offer, confirm);

  return (
    <header className="event-header">
      {eventTitle && <h1 className="event-header__title">{eventTitle}</h1>}
      {stateLabel && (
        <span className={`event-header__state-pill event-header__state-pill--${stateModifier}`}>
          {stateLabel}
        </span>
      )}

      {offer.calendar_event_id && team && (
        <a
          href={`/teams/${team.id}/confirms/${offer.calendar_event_id}`}
          className="event-header__event-link"
          data-testid="header-go-to-event"
        >
          Go to Event Details <i className="fas fa-arrow-right" aria-hidden="true" />
        </a>
      )}

      {!offer.calendar_event_id && onLinkEvent && (
        <Tippy
          content="Link this offer with an existing event on your calendar"
          placement="top"
        >
          <button
            type="button"
            className="btn btn-setlist-secondary btn-sm event-header__link-event-btn"
            onClick={onLinkEvent}
          >
            <i className="fas fa-link mr-1" aria-hidden="true" />
            Link Event
          </button>
        </Tippy>
      )}

      <div className="event-header__view-toggle">
        <ColumnVisibilityBar
          offerActive={offerActive}
          forecastActive={forecastActive}
          actualsActive={actualsActive}
          onToggleColumn={onToggleColumn}
        />
      </div>

      {templateBar}
    </header>
  );
};

V3OfferEventHeader.propTypes = {
  offer: PropTypes.object.isRequired,
  confirm: PropTypes.object,
  team: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) }),
  offerActive: PropTypes.bool.isRequired,
  forecastActive: PropTypes.bool.isRequired,
  actualsActive: PropTypes.bool.isRequired,
  onToggleColumn: PropTypes.func.isRequired,
  onLinkEvent: PropTypes.func,
  templateBar: PropTypes.node,
};

V3OfferEventHeader.defaultProps = {
  confirm: null,
  team: null,
  onLinkEvent: null,
  templateBar: null,
};

export default V3OfferEventHeader;
